/**
 * hooks/useIsMobile.js — утасны өргөнтэй дэлгэц эсэх (matchMedia).
 *
 * Вэбийг гар утасны браузераас нээхэд (аюул мэдээлэх, хяналт шалгалт
 * эхлүүлэх) модал/хүснэгтийг өөр зохион байгуулалтаар харуулахад хэрэглэнэ.
 * 640px — antd-ийн `sm` breakpoint-тэй тааруулав (Col xs/sm-тэй нэг утга).
 */
import { useEffect, useState } from "react";

const QUERY = "(max-width: 640px)";

export default function useIsMobile() {
  const [mobile, setMobile] = useState(() =>
    typeof window !== "undefined" && window.matchMedia
      ? window.matchMedia(QUERY).matches
      : false,
  );
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(QUERY);
    const on = (e) => setMobile(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", on);
    else mq.addListener(on);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", on);
      else mq.removeListener(on);
    };
  }, []);
  return mobile;
}
